import { DIDGenerator } from '@cp/shared/deviceId';

export const uuidGenerator: DIDGenerator = () => {
  return Promise.resolve(crypto.randomUUID());
};
